import React, { Component } from "react";
import {
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  message,
  Space, Switch,
  Typography,
  Tag,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  ButtonItem,
  InputItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { DollarOutlined, SnippetsOutlined, CarOutlined, EnvironmentOutlined, PhoneFilled, InfoCircleOutlined, UserOutlined } from "@ant-design/icons";
import PagosFactura from "../../FacturasSinOrdenDeCompra/PagosFactura/PagosFactura";
import NotasDeCreditoFactura from "../../NotasDeCredito/NotasDeCreditoFactura/NotasDeCreditoFactura";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import DevolucionesCompraFactura from "../../DevolucionesCompra/DevolucionesCompraFactura/DevolucionesCompraFactura";

const { Option } = Select;

moment.locale("es");

class VerFacturaOrdenDeCompra extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    todasInsumos: [],
    todasMonedas: null,
    objetoMonedas: null,
    impuestos: [],
    total: 0,
    totalPagar: 0,
    totalPagado: 0,
    subtotal: 0,
    ajusteSubtotal: 0,
    arrayImpuestos: [],
    arrayRetenciones: [],
    modalPagos: false,
    estado: 0,
    modalNotasDeCreditoFactura: false,
    id: this.props.location.state.id,
    notaDeCredito: false,
    mostrarDetalles: true,
    objetoUsosDeCFDI: null,
    todasUsosDeCFDI: null,
    objetoFormasDePago: null,
    todasFormasDePago: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "facturas/datosFactura",
        { empresaId: this.props.empresaId, facturaId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          let newState = {
            notaDeCredito: res.data.notaDeCredito,
            estado: res.data.factura.estado,
            total: res.data.factura.total,
            totalPagar: res.data.factura.totalPagar,
            totalPagado: res.data.factura.totalPagado,
            subtotal: res.data.factura.subtotal,
            arrayImpuestos: res.data.factura.arrayImpuestos,
            arrayRetenciones: res.data.factura.arrayRetenciones,
            ajusteSubtotal: res.data.factura.ajusteSubtotal,
            todasProveedores: res.data.proveedores,
            objetoProveedores: res.data.proveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
            todasProyectos: res.data.proyectos,
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre || value.descripcion}
                </Option>
              );
            }),
            todasMonedas: res.data.monedas,
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            ...(res.data.usosDeCFDI ? {
              todasUsosDeCFDI: res.data.usosDeCFDI,
              objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.c_UsoCFDI + " - " + value.descripcion}
                </Option>
              )),
            } : {}),
            ...(res.data.formasDePago ? {
              todasFormasDePago: res.data.formasDePago,
              objetoFormasDePago: res.data.formasDePago.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.c_FormaPago + " - " + value.descripcion}
                </Option>
              )),
            } : {}),
          }
          this.setState(newState, () => {
            this.formRef.current.setFieldsValue({
              ...res.data.factura,
              fechaFactura: moment(res.data.factura.fechaFactura),
              fechaPago: moment(res.data.factura.fechaPago),
              fechaVencimiento: moment(res.data.factura.fechaVencimiento),
              insumos: res.data.factura.insumos.map(insumo => {
                const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / insumo.cantidad)
                return { ...insumo, precioUnitarioConImpuestos }
              })
            });
          })
        } else {
          message.error("Error no se encontro informacion de la venta");
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  cerrarPagosFactura() {
    this.consultarTodo()
    this.setState({
      modalPagos: false,
    });
  }

  cerrarNotasDeCreditoFactura() {
    this.consultarTodo()
    this.setState({
      modalNotasDeCreditoFactura: false,
    });
  }

  cerrarDevolucionesFactura() {
    this.consultarTodo()
    this.setState({
      modalDevolucionesFactura: false,
    });
  }
  
  agregarNotaDeCredito() {
    this.props.history.push('/panel/agregarNotaDeCredito', { facturaId: this.state.id });
  }

  agregarDevolucion() {
    this.props.history.push('/panel/agregarDevolucionCompra', { facturaId: this.state.id });
  }

  getInsumosColumns() {
    return [
      { title: "Clave",  width: "5%" },
      { title: "Insumo", width: "25%" },
      { title: "Unidad", width: "5%" },
      { title: "P.U.",   width: "12%" },
      { title: "P.U. c/Imp.", width: "12%" },
      { title: "Cant.", width: "10%" },
      { title: "Desc.", width: "10%" },
      { title: "Subtotal / Imp. / Total", width: "16%" },
    ];
  }

  renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <tr>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {insumoSeleccionado?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "insumoId"]} fieldKey={[arrayKey, "insumoId"]} required noStyle>
              <SelectItem sinBorde style={{ width: "100%" }} placeholder="Insumo" disabled>
                {this.state.objetoInsumos}
              </SelectItem>
            </FormItem>
          </td>
          <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                  const insumoSeleccionado = this.state.todasInsumos?.find(
                    (insumo) => insumo._id.toString() === insumoId?.toString()
                  );
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                      {insumoSeleccionado?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "precioUnitario"]} fieldKey={[arrayKey, "precioUnitario"]} noStyle required>
              <InputNumberItem sinBorde placeholder="Precio Unitario" disabled dinero />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem name={[name, "precioUnitarioConImpuestos"]} noStyle required shouldUpdate>
              <InputNumberItem sinBorde disabled placeholder="P.U. con Impuestos" dineroDisabled />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[arrayKey, "cantidad"]} required number noStyle>
              <InputNumberItem sinBorde placeholder="Cantidad" disabled />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "descuento"]} fieldKey={[arrayKey, "descuento"]} required number noStyle shouldUpdate initialValue={0}>
              <InputNumberItem sinBorde placeholder="Descuento" porcentaje max={100} disabled />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const subtotal  = getFieldValue(["insumos", arrayKey, "subtotal"])  || 0;
                const impuestos = getFieldValue(["insumos", arrayKey, "impuestos"]) || 0;
                const total     = getFieldValue(["insumos", arrayKey, "total"])     || 0;
                return (
                  <div className="celda-totales" style={{ fontSize: "12px" }}>
                    <div>{dineroDisabledMask(subtotal)}</div>
                    <div>{dineroDisabledMask(impuestos)}</div>
                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                  </div>
                );
              }}
            </FormItem>
            <FormItem {...restField} name={[name, "subtotal"]}  fieldKey={[arrayKey, "subtotal"]}  hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} fieldKey={[arrayKey, "impuestos"]} hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "total"]}     fieldKey={[arrayKey, "total"]}     hidden><InputNumberItem /></FormItem>
          </td>
        </tr>
        {this.state.mostrarDetalles && (
          <FormItem
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              const prev = prevValues.insumos?.[arrayKey];
              const curr = currentValues.insumos?.[arrayKey];
              return (
                prev?.cantidad !== curr?.cantidad ||
                prev?.insumoId !== curr?.insumoId ||
                prev?.precioUnitario !== curr?.precioUnitario
              );
            }}
          >
            {({ getFieldValue }) => {
              const insumos    = getFieldValue("insumos");
              const insumoData = insumos?.[arrayKey];
              const cantidad   = insumoData?.cantidad;
              const insumoId   = insumoData?.insumoId;
              const costo      = insumoData?.precioUnitario;

              let insumo = null;
              if (insumoId && this.state.todasInsumos) {
                insumo = this.state.todasInsumos.find((v) => v._id === insumoId);
              }
              if (!insumo) return null;
              return (
                <InsumoDetalleRow
                  insumo={insumo}
                  cantidad={cantidad}
                  costo={costo}
                  colSpans={{ details: 2, projection: 2, filler: 2 }}
                  disabledModal={true}
                />
              );
            }}
          </FormItem>
        )}
      </React.Fragment>
    );
  }

  getObservacionesConfig() {
    return {
      totales: (
        <div style={{ marginTop: 8 }}>
          <table className="table" style={{ borderCollapse: "collapse", width: "100%", margin: 0 }}>
            <tbody>
              <tr style={{ marginBottom: 10 }}>
                <th className="td-totales-center" style={{ width: "50%" }}></th>
                <td className="td-totales-center" style={{ width: "30%" }}>
                  <Tag style={{ backgroundColor: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959", fontWeight: 600, padding: "2px 30px", borderRadius: "6px" }}>
                    Ajuste
                  </Tag>
                </td>
                <td className="td-totales-center" style={{ width: "30%" }}></td>
              </tr>
              <tr>
                <th className="th-totales" style={{ width: "50%" }}>Subtotal</th>
                <td className="td-totales-right" style={{ width: "20%" }}>
                  <InputNumberItem sinBorde dineroDisabled disabled value={this.state.ajusteSubtotal} />
                </td>
                <td className="td-totales-right" style={{ width: "50%" }}>
                  {dineroDisabledMask(this.state.subtotal)}
                </td>
              </tr>
            </tbody>
            {this.state.arrayImpuestos.map((valueArray) => (
              <tbody key={valueArray.descripcionFactura}>
                <tr>
                  <th className="th-totales">{valueArray.descripcionFactura}</th>
                  <td className="td-totales-right" style={{ width: "20%" }}>
                    <InputNumberItem sinBorde dineroDisabled disabled value={valueArray.ajusteImpuesto} />
                  </td>
                  <td className="td-totales-right">
                    {dineroDisabledMask(valueArray.totalImpuestos)}
                  </td>
                </tr>
              </tbody>
            ))}
            <tbody>
              <tr>
                <th className="th-totales">Total</th>
                <td className="td-totales-right" style={{ width: "20%" }}></td>
                <td className="td-totales-right">
                  {dineroDisabledMask(this.state.total)}
                </td>
              </tr>
            </tbody>
            {this.state.arrayRetenciones.map((value) => (
              <tbody key={value.descripcionFactura}>
                <tr>
                  <th className="th-totales">{value.descripcionFactura}</th>
                  <td className="td-totales-right" style={{ width: "20%" }}>
                    <InputNumberItem sinBorde dineroDisabled disabled value={value.ajusteRetencion} />
                  </td>
                  <td className="td-totales-right">
                    {dineroDisabledMask(value.totalRetenciones)}
                  </td>
                </tr>
              </tbody>
            ))}
            <tbody>
              <tr>
                <th className="th-totales">Total a pagar</th>
                <td className="td-totales-right" style={{ width: "20%" }}></td>
                <td className="td-totales-right">
                  {dineroDisabledMask(this.state.totalPagar)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    };
  }

  renderProyectoCard() {
    return (
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");

          const proyecto = proyectoId
            ? this.state.todasProyectos?.find((v) => v._id === proyectoId)
            : null;

          const proveedor = proveedorId
            ? this.state.todasProveedores?.find((v) => v._id === proveedorId)
            : null;

          if (!proyecto && !proveedor) return null;

          const proveedorSections = proveedor
            ? [
                {
                  title: "Datos generales",
                  icon: <InfoCircleOutlined />,
                  iconColor: "#00BFD6",
                  lg: 14,
                  items: [
                    {
                      label: "Nombre",
                      value: proveedor.nombre
                        ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                        : proveedor.razonSocial || "-",
                      bold: true,
                    },
                    { label: "RFC",      value: proveedor.rfc      || "-" },
                    { label: "Correo",   value: proveedor.correo   || "-" },
                    { label: "Teléfono", value: proveedor.telefono || "-" },
                    { label: "Celular",  value: proveedor.celular  || "-" },
                  ],
                },
                {
                  title: "Contacto",
                  icon: <PhoneFilled />,
                  iconColor: "#DB2777",
                  lg: 10,
                  items: [
                    { label: "Nombre",          value: proveedor.nombreContacto   || "-" },
                    { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                    { label: "Correo",          value: proveedor.correoContacto   || "-" },
                    { label: "Días de crédito", value: proveedor.diasCredito      ?? "-" },
                  ],
                },
              ]
            : [];

          if (!proyecto) {
            return (
              <Row>
                <InfoCard
                  title="PROVEEDOR"
                  accentColor="#00BFD6"
                  compact
                  sections={proveedorSections}
                />
              </Row>
            );
          }

          return (
            <Row>
              <InfoCard
                title="PROYECTO"
                accentColor="#00BFD6"
                icon={<InfoCircleOutlined />}
                compact
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 8,
                    items: [
                      { label: "Nombre",      value: proyecto.nombre      || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 8,
                    items: proyecto.calle
                      ? [{ label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` }]
                      : [
                          { label: "Marca",  value: proyecto.marca  || "-" },
                          { label: "Modelo", value: proyecto.modelo || "-" },
                          { label: "Placas", value: proyecto.placas || "-" },
                        ],
                  },
                  {
                    title: "Detalles",
                    icon: <CarOutlined />,
                    iconColor: "#FF6A0D",
                    lg: 8,
                    items: [
                      { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                      { label: "ID",   value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                    ],
                  },
                ]}
                splitWith={
                  proveedor
                    ? {
                        title: "PROVEEDOR",
                        accentColor: "#00BFD6",
                        icon: <UserOutlined />,
                        compact: true,
                        sections: proveedorSections,
                      }
                    : undefined
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  render() {
    const isMobile = window.innerWidth < 768;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Factura Orden de Compra"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="verFacturaOrdenDeCompra"
              layout
            >
              <div style={{ padding: '0 16px', marginBottom: 16 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                isMobile={isMobile}
                cards={[
                  {
                    title: "Datos Factura",
                    lg: 18,
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="codigoFactura" label="Codigo Factura" margin pattern>
                            <InputItem placeholder="Codigo Factura" disabled />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Días de crédito" name="diasCredito" required number margin>
                            <InputNumberItem placeholder="Días de crédito" disabled />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin>
                            <SelectItem placeholder="Uso de CFDI" disabled>
                              {this.state.objetoUsosDeCFDI}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Fecha de Factura" name="fechaFactura" required margin>
                            <DatePickerItem placeholder="Fecha de Factura" allowClear={false} disabled />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Fecha probable Pago" name="fechaPago" required margin>
                            <DatePickerItem placeholder="Fecha probable Pago" allowClear={false} disabled />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="formaDePagoId" label="Forma de Pago" margin>
                            <SelectItem placeholder="Forma de Pago" disabled>
                              {this.state.objetoFormasDePago}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="uuid" label="UUID" margin pattern required>
                            <InputItem placeholder="UUID" disabled />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="descripcion" label="Descripcion" margin pattern>
                            <InputItem placeholder="Descripcion" disabled />
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="metodoPago" label="Método de Pago" margin>
                            <SelectItem placeholder="Método de Pago" disabled>
                              <Option value={1}>PUE - Pago en Una sola Exhibición</Option>
                              <Option value={2}>PPD - Pago en Parcialidades o Diferido</Option>
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Fecha Vencimiento" name="fechaVencimiento" required margin>
                            <DatePickerItem placeholder="Fecha Vencimiento" allowClear={false} disabled />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem
                            disabled
                            onChange={(value) => {
                              if (value === "60c7e4396465ad440c41c15a") {
                                this.formRef.current.setFieldsValue({
                                  tipoDeCambio: 1,
                                });
                              }
                            }}
                            placeholder="Moneda"
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                          {({ getFieldValue, setFieldsValue }) => {
                            const monedaId = getFieldValue('monedaId');
                            const esMxn = monedaId === '60c7e4396465ad440c41c15a';
                            if (esMxn && getFieldValue('tipoDeCambio') !== 1) {
                              setTimeout(() => setFieldsValue({ tipoDeCambio: 1 }), 0);
                            }
                            return esMxn ? (
                              <FormItem
                                name="tipoDeCambio"
                                hidden
                                initialValue={1}
                              >
                                <InputNumberItem />
                              </FormItem>
                            ) : (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                initialValue={1}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem
                                  disabled
                                  dinero
                                  placeholder="T. Cambio"
                                />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                      renderHeader: () => (
                        <Row justify="end" style={{ marginBottom: "0px", marginRight: "15px" }}>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Mostrar detalles:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) =>
                                  this.setState({ mostrarDetalles: checked })
                                }
                              />
                            </Space>
                          </Col>
                        </Row>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                actionButtons={
                  <>
                    {this.state.estado !== 0 ?
                      <ButtonItem
                        type="primary"
                        icon={<SnippetsOutlined />}
                        onClick={this.agregarNotaDeCredito.bind(this)}
                        cyanB
                        hotkey="shift+n"
                      >
                        {isMobile ? "Agregar Nota de Crédito" : "Nota Créd."}
                      </ButtonItem>
                      : null}
                    {this.state.estado !== 0 && this.state.notaDeCredito ?
                      <ButtonItem
                        type="primary"
                        icon={<SnippetsOutlined />}
                        negroB
                        onClick={() => this.setState({ modalNotasDeCreditoFactura: true })}
                      >
                        Notas de credito
                      </ButtonItem>
                      : null}
                    {this.state.estado !== 0 ?
                      <ButtonItem
                        type="primary"
                        icon={<SnippetsOutlined />}
                        onClick={this.agregarDevolucion.bind(this)}
                        cyanB
                        hotkey="shift+d"
                      >
                        {this.isMobile ? "Agregar Devolucion" : "Dev."}
                      </ButtonItem>
                      : null}
                    {this.state.estado !== 0 && this.state.devoluciones ?
                      <ButtonItem
                        type="primary"
                        icon={<SnippetsOutlined />}
                        blanco
                        onClick={() => this.setState({ modalDevolucionesFactura: true })}
                      >
                        Devoluciones
                      </ButtonItem>
                      : null}
                    {this.state.totalPagado > 0 &&
                      <ButtonItem
                        type="primary"
                        icon={<DollarOutlined />}
                        verdeB
                        onClick={() => this.setState({ modalPagos: true })}
                        hotkey="shift+p"
                      >
                        Pagos
                      </ButtonItem>
                    }
                    <ButtonItem
                      type="primary"
                      rojoB
                      onClick={this.atras.bind(this)}
                      hotkey="shift+r"
                    >
                      Regresar
                    </ButtonItem>
                  </>
                }
              />
            </Form>
          </Spin>
        </div>
        <NotasDeCreditoFactura
          history={this.props.history}
          visible={this.state.modalNotasDeCreditoFactura}
          id={this.state.id}
          cerrarNotasDeCreditoFactura={this.cerrarNotasDeCreditoFactura.bind(this)}
        />
        <DevolucionesCompraFactura
          history={this.props.history}
          visible={this.state.modalDevolucionesFactura}
          id={this.state.id}
          cerrarDevolucionesFactura={this.cerrarDevolucionesFactura.bind(this)}
        />
        <PagosFactura
          visible={this.state.modalPagos}
          id={this.state.id}
          cerrarPagosFactura={this.cerrarPagosFactura.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerFacturaOrdenDeCompra);
